import React, { Component, Fragment, useRef } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import { Button, Table } from "react-bootstrap";
import cookieManager from "../../../../utils/cookieManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import SalesInvoiceReportMiddleware from "../../../../middleware/modules/report/sales-report";
import ReportPurchasing from "./purchasing-report";

const MySwal = withReactContent(Swal);
export class PriceComparisonPurchasing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Report"), class: " text-gray-600" },
        { link: null, title: i18n.t("Price Comparison"), class: " text-gray-500" },
      ],
      arr: null,
      listData: null,
      fill: 0,
      bound: 0,
      search: '',
      idSupplier: null,
      supplierList: [],
      supplierText: i18n.t("All"),
      supplierCurrent: null,
      idBranch: null,
      itemCurrent: null,
      itemText: i18n.t("All"),
      itemList: [],
      showData: false,
      showDataDetail: false,
      orderList: null,
      idSO: null,
      show: 0
    }
    this.handlerSelect = this.handlerSelect.bind(this);
    this.handlerDateTime = this.handlerDateTime.bind(this);
  }
  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }
  handlerSelect(e, name, currentState) {
    var key = name;
    var value = null;
    if (e != null) {
      value = e.value;
    }
    this.setState({
      [key]: value,
      [currentState]: e,
    }
    );
  }

  handlerDateTime(e, name) {
    var key = name;
    var value = e
    this.setState({
      [key]: value
    })
  }

  renderLoading() {
    Swal.fire({
      title: 'Loading',
      width: "200px",
      heightAuto: true
    });
    Swal.showLoading();
  }
  alertHandler(title, message, icon) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }

  async convertExcel() {
    if (this.state.employeeCurrent != null) {
      this.setState({ progressConvert: true })

      const params = {
        date: moment(this.state.date).format('YYYY-MM-DD'),
        idEmployee: this.state.idEmployee,
      }

      var salesName = this.state.employeeCurrent?.label
      var nameFile = 'Report Visiting ' + (moment(this.state.date).format('DD MM YYYY')) + ' Sales ' + salesName;

      this.renderLoading();
      const token = cookieManager.getUserToken();
      axios({
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: process.env.REST_URL + "sales/report-visit-excel",
        method: "GET",
        params: params,
        responseType: "blob",
      }).then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.close();
          this.setState({ progressConvert: false })
          this.alertHandler('Convert Excel', 'Download Successfully', 'success')
          var urlCreator = window.URL || window.webkitURL;
          const blobUrl = urlCreator.createObjectURL(response.data);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = blobUrl;
          link.setAttribute("download",
            nameFile + '.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          Swal.close();
        }
      }).catch((error) => {
        this.setState({ progressConvert: false })
        this.alertHandler('Convert Excel', 'Internal Server Error', 'info')
      });
    }

  }

  showTracking() {
    const post = {
      idItem: this.state.itemCurrent ? this.state.itemCurrent.value : '',
      idSupplier: this.state.supplierCurrent ? this.state.supplierCurrent.value : '',
    }

    this.props.getDataPurchasing(post)
  }

  handlerSearch(e) {
    var value = e.target.value;
    let data = this.state.listData
    var updateList = [...this.state.arr];

    if (value != "") {

      const valueLower = value.toLowerCase();

      const updateList = this.state.arr.map(branch => {
        const isBranchMatch = branch.name?.toLowerCase().includes(valueLower);

        const filteredItems = branch.item.filter(itm =>
          itm.name_item?.toLowerCase().includes(valueLower) ||
          itm.code?.toLowerCase().includes(valueLower) ||
          itm.brand?.toLowerCase().includes(valueLower) ||
          itm.category?.toLowerCase().includes(valueLower) ||
          itm.unit?.toLowerCase().includes(valueLower) ||
          itm.date?.toLowerCase().includes(valueLower) ||
          itm.price?.toLowerCase().includes(valueLower)
        );

        if (isBranchMatch) {
          return {
            ...branch,
            item: branch.item
          };
        } else if (filteredItems.length > 0) {
          return {
            ...branch,
            item: filteredItems
          };
        }

        return null;
      }).filter(branch => branch !== null);

      this.setState({
        bound: 1,
        search: value,
        listData: updateList,
      });
    } else {
      this.setState({
        fill: 1,
        search: '',
        bound: 0,
        listData: data
      });
    }
  }

  render() {
    const { helper, isProcessing, dataPurchasing } = this.props;
    let arr = [];
    if (helper != null && helper != undefined) {
      this.state.supplierList = helper.supplier;
      this.state.itemList = helper.item;
    }

    if (dataPurchasing.data != null && dataPurchasing.data != undefined) {
      this.state.arr = dataPurchasing.data
      if (this.state.bound == 0) {
        this.state.fill = 0
      }
    }

    if (this.state.fill == 0 && this.state.arr != undefined) {
      this.state.listData = this.state.arr
      this.state.fill = 1;
    }


    return (
      <div className="card-body pt-3">
        <div className="row mb-4">
          <div className="col-sm-3">
            <Select2
              isClearable={true}
              name={"idSupplier"}
              required={true}
              onChange={async (e) => {
                if (e != this.state.supplierCurrent) {
                  await this.handlerSelect(
                    e,
                    "idSupplier",
                    "supplierCurrent"
                  );
                }
              }}
              options={this.state.supplierList}
              title={i18n.t("Supplier")}
              value={this.state.supplierCurrent}
              currentState={"supplierCurrent"}
              placeholder={this.state.supplierText}
            />
          </div>
          <div className="col-sm-3">
            <Select2
              isClearable={true}
              name={"idItem"}
              required={true}
              onChange={async (e) => {
                if (e != this.state.itemCurrent) {
                  await this.handlerSelect(
                    e,
                    "idItem",
                    "itemCurrent"
                  );
                }
              }}
              options={this.state.itemList}
              title={i18n.t("Item")}
              value={this.state.itemCurrent}
              currentState={"itemCurrent"}
              placeholder={this.state.itemText}
            />
          </div>

          <div className="row align-items-center mb-4">
            <div className="col-sm-6 d-flex justify-content-start">
              <Button
                onClick={(e) => {
                  this.setState({ showData: true, showDataDetail: false });
                  this.showTracking();
                }}
                variant="success"
                className="btn btn-md btn btn-success mt-8 "
              >
                {isProcessing ?
                  <span className="indicator-progress " >{i18n.t("Please wait")}...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                  :
                  <span className="indicator-label"><FontAwesomeIcon icon={faEye}></FontAwesomeIcon> {i18n.t("Show")}</span>
                }

              </Button>
              <button className="btn btn-md dropdown-toggle btn-secondary mt-8 " style={{ marginLeft: '10px' }} type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {i18n.t("Convert ")}
              </button>
              <div className="dropdown-menu dropdown-menu-area" aria-labelledby="dropdownMenuButton">
                <a className="dropdown-item"
                  href={"/report/price-comparison/print/purchasing/" + (
                    this.state.supplierCurrent != null ? this.state.supplierCurrent.value : 'all') + "/" +
                    (this.state.itemCurrent != null ? this.state.itemCurrent.value : 'all')
                  } target="_blank">
                  <FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon>  {i18n.t("PDF")}</a>
                {/* <a className="dropdown-item " href="#" onClick={()=>this.convertExcel()}><FontAwesomeIcon icon={faFileExcel}></FontAwesomeIcon>  {i18n.t("Excel")} </a> */}

              </div>

            </div>
            <div className="col-sm-6 d-flex justify-content-end">
              {this.state.showData ?
                <Fragment>
                  <div className="col-md-4 mt-3 ">
                    <input
                      type={"text"}
                      className="form-control form-control-md justify-content-right"
                      placeholder="Search"
                      name={"search"}
                      title={""}
                      value={this.state.search}
                      onChange={(e) => this.handlerSearch(e)}
                    />
                  </div>
                </Fragment>
                : null
              }

            </div>
          </div>
        </div>
        {this.state.listData != undefined && this.state.showData ?
          <Fragment>
            <div className="row">
              <ReportPurchasing
                {...this.props}
                arr={this.state.listData}
                updateShow={this.updateShow}
              ></ReportPurchasing>
            </div>
          </Fragment>
          : null}
      </div>
    );
  }
}

export default PriceComparisonPurchasing;
